import { onMounted } from 'vue'

export const useWistiaScriptLoader = () => {
  const loadWistiaScript = (url) => {
    if (isWistiaScriptAlreadyLoaded(url)) return
    const wistiaPlayerScript = document.createElement('script')
    wistiaPlayerScript.setAttribute('src', url)
    wistiaPlayerScript.setAttribute('async', 'true')
    document.head.appendChild(wistiaPlayerScript)
  }
  const isWistiaScriptAlreadyLoaded = (url) => {
    const wistiaPlayerScript = document.querySelectorAll(`[src="${url}"]`)
    return wistiaPlayerScript.length > 0
  }
  const loadWistiaVideoScript = (videoId) => {
    const url = `https://fast.wistia.com/embed/medias/${videoId}.jsonp`
    if (isWistiaScriptAlreadyLoaded(url)) return
    loadWistiaScript(url)
  }

  onMounted(() => {
    loadWistiaScript('https://fast.wistia.com/assets/external/E-v1.js')
  })

  return {
    loadWistiaVideoScript,
  }
}
